export default "__VITE_ASSET__C9A_2pg3__"